import axios from 'axios';

/// 获取支持的语言
export function getSupportLangs(){
  return axios.get('/owm_api/get_support_language')
}